import { render } from "./TerminalCategories.vue?vue&type=template&id=4e532174&scoped=true&ts=true"
import script from "./TerminalCategories.vue?vue&type=script&lang=ts"
export * from "./TerminalCategories.vue?vue&type=script&lang=ts"

import "./TerminalCategories.vue?vue&type=style&index=0&id=4e532174&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e532174"]])

export default __exports__